<template>
    <v-container fluid>
      <v-card>
        <v-toolbar color="secondary" flat dense>
          <v-toolbar-title>
            <span style="color: red">Copy Draft To Actual Transfer</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- <v-btn color="primary" small text to="/copy-transfer-drafts">
            <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
          </v-btn> -->
        </v-toolbar>
        <v-card-text>
          <editor :initial="dataItem"></editor>
        </v-card-text>
      </v-card>
  
      <snackbar ref="snackbar"></snackbar>
    </v-container>
  </template>
  
  <script>
  import Editor from "../_components/copy_editor.vue";
  export default {
    components: {
      Editor,
    },
    computed: {},
    data: () => ({
      dataItem: {},
      DefaultCustomer: null,
      AccountsVersion: null,
      outsourcedData: [],
      salePayments: [],
      docCreate: false,
      copyStatus: false,
    }),
    watch: {
      "$route.params.id": {
        handler: "getById",
        immediate: true,
      },
    },
    methods: {
      getById(val) {
        const self = this;
        // get record
        this.$store
          .dispatch("get", `/draft-inventory-transfers/${val}`)
          .then((res) => {
            if (res.ResultCode == 1200) {
              self.dataItem = res.ResponseData;
            } else {
              this.$refs.snackbar.show(res.ResultDesc, "red");
            }
          })
          .catch((err) => {
            this.$refs.snackbar.show(err, "red");
          });
      },
      getGenSettings() {
        const self = this;
        this.$store
          .dispatch("get", `/general-settings`)
          .then((res) => {
            if (res.ResultCode == 1200) {
              self.DefaultCustomer = res.ResponseData.DefaultCustomer;
              self.AccountsVersion = res.ResponseData.AccountsVersion;
            } else {
              this.$refs.snackbar.show(res.msg, "red");
            }
          })
          .catch((err) => {
            this.$refs.snackbar.show(err, "red");
          });
      },
    },
    created() {
      this.getGenSettings();
    },
  };
  </script>